const addCero = (date) => ((date >= 0 && date < 10) ? `0${date}` : date);
export const formatDate = (fecha) => {
  const fechaAux = new Date(fecha);
  return `${addCero(fechaAux.getUTCDate())}/${addCero(fechaAux.getUTCMonth() + 1)}/${fechaAux.getUTCFullYear()}`;
};

export const formatDateToUTC = (date) => {
  const dateMiliseconds = Date.UTC(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds()
  );

  return new Date(dateMiliseconds);
};

export const fechaHora = (fecha) => {
  // console.log('fechaHora input:', fecha, 'Type:', typeof fecha);
  
  if (!fecha) return 'Fecha no disponible';
  
  try {
    const fechaNew = new Date(fecha);
    // console.log('fechaNew:', fechaNew, 'isNaN:', isNaN(fechaNew.getTime()));
    
    // Verificar si la fecha es válida
    if (isNaN(fechaNew.getTime())) {
      return 'Fecha inválida';
    }
    
    // Formatear como DD/MM/YYYY HH:MM
    const dia = addCero(fechaNew.getDate());
    const mes = addCero(fechaNew.getMonth() + 1);
    const año = fechaNew.getFullYear();
    const hora = addCero(fechaNew.getHours());
    const minuto = addCero(fechaNew.getMinutes());
    
    const result = `${dia}/${mes}/${año} ${hora}:${minuto}`;
    // console.log('fechaHora result:', result);
    return result;
  } catch (error) {
    console.error('Error al formatear fecha:', error, fecha);
    return 'Error en fecha';
  }
};

// Nueva función específica para formato año-mes-día
export const fechaYMD = (fecha) => {
  if (!fecha) return 'Fecha no disponible';
  
  try {
    const fechaNew = new Date(fecha);
    
    if (isNaN(fechaNew.getTime())) {
      return 'Fecha inválida';
    }
    
    const año = fechaNew.getFullYear();
    const mes = addCero(fechaNew.getMonth() + 1);
    const dia = addCero(fechaNew.getDate());
    const hora = addCero(fechaNew.getHours());
    const minuto = addCero(fechaNew.getMinutes());
    
    return `${año}-${mes}-${dia} ${hora}:${minuto}`;
  } catch (error) {
    console.error('Error al formatear fecha YMD:', error, fecha);
    return 'Error en fecha';
  }
};

export const fechaHoraRango = (fecha1, fecha2) => {
  const fechaNew1 = new Date(fecha1);
  const fechaNew2 = new Date(fecha2);
  return `${addCero(fechaNew1.getDate())}/${addCero(fechaNew1.getMonth() + 1)}/${fechaNew1.getFullYear()} (${addCero(fechaNew1.getHours())}:${addCero(fechaNew1.getMinutes())} - ${addCero(fechaNew2.getHours())}:${addCero(fechaNew2.getMinutes())})`;
};
